import { DashboardRouter } from "../dashboard.router";

export class HospitalCentersRouter {
    
    static getRoute(): string {
        return `${DashboardRouter.getRoute()}/hospital-centers`
    }

}